module.exports = __webpack_public_path__ + "img/underline-black.c780b27a.svg";